export const THEME_MODE = /** @type {const} */ ({
  LIGHT: {
    value: 1,
    name: 'light'
  },
  DARK: {
    value: 2,
    name: 'dark'
  },
  SYSTEM: {
    value: 3,
    name: 'system'
  }
})

export const THEME_TYPE = /** @type {const} */ ({
  DEFAULT: {
    value: 0,
    name: 'default'
  },
  BVB: {
    value: 1,
    name: 'bvb'
  },
  CHELSEA: {
    value: 2,
    name: 'chelsea'
  }
})

// webview support
export const APP_THEME_TO_THEME_INFO_MAP = /** @type {const} */ ({
  1: {
    mode: THEME_MODE.DARK,
    type: THEME_TYPE.DEFAULT
  },
  2: {
    mode: THEME_MODE.DARK,
    type: THEME_TYPE.CHELSEA
  },
  3: {
    mode: THEME_MODE.DARK,
    type: THEME_TYPE.BVB
  },
  4: {
    mode: THEME_MODE.LIGHT,
    type: THEME_TYPE.DEFAULT
  },
  5: {
    mode: THEME_MODE.DARK,
    type: THEME_TYPE.CHELSEA
  },
  6: {
    mode: THEME_MODE.DARK,
    type: THEME_TYPE.BVB
  },
})
